import React, { Fragment, useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { Card, Button, Icon } from "rbx"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Components, { methods } from "../methods-and-components/methods-and-components"
import LoadingOverlay from "../../loading-overlay"
import "../../../../styles/workspace.scss"
import "../../../../styles/loading.scss"
import { faBoxes, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'


const EditAttendancePackage = (props) => {

  const { editAttendancePackage, setEditAttendancePackage, getAttendancePackages, getAndSetEvents, getAttendances, professionals, setProfessionals, hasUnsavedChanges, setHasUnsavedChanges, setNotification } = props

  const [patientId, setPatientId] = useState(editAttendancePackage && editAttendancePackage.patientId)
  const [patientIdError, setPatientIdError] = useState(null)
  const [name, setName] = useState(editAttendancePackage && editAttendancePackage.name)

  const [clickedSave, setClickedSave] = useState(false)
  const [clickedDelete, setClickedDelete] = useState(false)

  const [loading, setLoading] = useState(false)
  const [redirectToLogin, setRedirectToLogin] = useState(false)

  const mandatoryFields = [
    patientId,
    name,
  ]

  let errorList = [
    patientIdError,
  ]

  if (redirectToLogin || !editAttendancePackage) {
    return <Redirect to="/app"/>
  }

  return (
    <Fragment>
      {loading && <LoadingOverlay/>}

      <Components.CardWithOverlay
        cardType="fullViewer"
        headerClassName=""
        title="Editar Pacote para Paciente"
        titleColorClassName=""
        icon={faBoxes}
        cardFooter={
          <Fragment>
            <Card.Footer.Item></Card.Footer.Item>
            <Card.Footer.Item>
              <Button.Group align="centered">
                <Button
                  color="info"
                  size="medium"
                  className="has-text-weight-semibold"
                  onClick={() => {setClickedSave(true)}}
                >
                  <span>Salvar</span>
                </Button>
              </Button.Group>
            </Card.Footer.Item>
            <Card.Footer.Item>
              <Button.Group align="right">
                <Button
                  outlined
                  color="danger"
                  onClick={() => {setClickedDelete(true)}}
                >
                  <Icon >
                    <FontAwesomeIcon icon={faTrash} />
                  </Icon>
                  <span>Excluir Pacote</span>
                </Button>
              </Button.Group>
            </Card.Footer.Item>
          </Fragment>
        }
        setOpenCard={setEditAttendancePackage}
        hasConfirmationOnClose={true}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
        setNotification={setNotification}
      >

        <Components.EditAttendancePackage
          editAttendancePackage={editAttendancePackage}
          setEditAttendancePackage={setEditAttendancePackage}
          getAttendances={editAttendancePackage.getAttendances}
          getAttendancePackages={getAttendancePackages || editAttendancePackage.getAttendancePackages}
          getAndSetEvents={editAttendancePackage.getAndSetEvents || getAndSetEvents || getAttendances}
          professionals={professionals}
          setProfessionals={setProfessionals}
          clickedSave={clickedSave}
          setClickedSave={setClickedSave}
          clickedDelete={clickedDelete}
          setClickedDelete={setClickedDelete}
          hasUnsavedChanges={hasUnsavedChanges}
          setHasUnsavedChanges={setHasUnsavedChanges}
          setNotification={setNotification}
          setLoading={setLoading}
          setRedirectToLogin={setRedirectToLogin}
        />

      </Components.CardWithOverlay>

    </Fragment>
  )
}

export default EditAttendancePackage